module.exports = __webpack_public_path__ + "static/media/user.0df47679.png";